import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, input } from "@angular/core";

@Component({
	selector: 'skl-fiscal-suz-errors-toast-component',
	template: `
		<div>{{text()}}</div>
		<ul>
			@for (message of messages(); track message) {
				<li>{{message}}</li>
			}
		</ul>
	`,
	styles: `
		:host {
			display: flex;
			flex-direction: column;
			gap: var(--gutter-small);
			font-size: .9rem;
			color: var(--text-minor-color);
		}
	`,
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class FiscalSuzErrorsToastComponent {
	public readonly dismiss = input<() => void>();
	public readonly text = input<string>();
	public readonly messages = input<string[]>();
}
